<template>
    <div class="p-0" @mouseleave="toggleDisplayMenu">

        <b-navbar toggleable="xl" class="navbar-horizontal" id="main-nav" :class="{'fix-nav': isScroll}">
            <b-navbar-brand class="text-center main-logo" >
                <router-link :to="{ name: 'home' }" width="100" aria-label="home">
                    <img src="/images/header/PIP-WestChester-Logo.svg" alt="PIP West Chester logo">
                </router-link>
            </b-navbar-brand>
            <a href="#mobile-nav"
                ><i class="fas fa-bars d-lg-block d-xl-none"></i
            ></a>
            <mobile-nav></mobile-nav>
            <b-collapse is-nav id="nav-collapse">
                <b-navbar-nav>
                    <li class="nav-item dropdown" v-if="useProducts">
                        <a
                            class="nav-link dropdown-toggle"
                            href="/products"
                            id="navbarDropdownMenuLink"
                            @mouseover="hover = true"

                        >
                            {{ $t("nav.products") }}
                        </a>
                        <ul :class="{showMenu:hover}"
                            @mouseleave="hover = false"
                            id="products-menu"
                            class="dropdown-menu"
                            aria-labelledby="navbarDropdownMenuLink"
                        >
                            <li
                                v-for="(category, index) in categories"
                                :key="'scID' + index"
                                :class="{
                                    'dropdown-submenu': category.commodity_code.length
                                }"
                            >
                                <router-link
                                    :to="{
                                        name: 'products',
                                        query: { scID: category.select_code.id }
                                    }"
                                    :class="{
                                        'dropdown-toggle': category.commodity_code.length
                                    }"
                                    class="dropdown-item"
                                    >{{ category.select_code.title }}
                                </router-link>
                                <ul
                                    class="dropdown-menu submenu"
                                    :class="{'maxHeight':submenuHeight(category.commodity_code)}"
                                    v-if="category.commodity_code"
                                >
                                    <li class="submenu-header mx-0">
                                        {{ category.select_code.title }}
                                    </li>
                                    <li
                                        v-for="(subCategory, index) in category.commodity_code"
                                        :key="'ccID' + index"
                                    >
                                        <router-link
                                            :to="{
                                                name: 'products',
                                                query: {
                                                    scID: category.select_code.id,
                                                    ccID: subCategory.id
                                                }
                                            }" v-html="subCategory.title"></router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <b-nav-item to="/company">Company</b-nav-item>
                    <!-- <b-nav-item to="/literature">{{
                        $t("nav.literature")
                    }}</b-nav-item>
                    <b-nav-item to="/contact">{{
                        $t("nav.contact")
                    }}</b-nav-item> -->
                    <b-dropdown text="Brands" class="m-md-2 main-nav-dropdown">
                        <b-dropdown-item href="/brands/boss">Boss</b-dropdown-item>
                        <b-dropdown-item href="/brands/hearos">Hearos</b-dropdown-item>
                        <b-dropdown-item href="/brands/mud">Mud</b-dropdown-item>
                        <b-dropdown-item href="/brands/prosafety">PIP Pro Safety</b-dropdown-item>
                        <b-dropdown-item href="/brands/safetyworks">Safety Works</b-dropdown-item>
                        <b-dropdown-item href="/brands/westcountygardener">West County Gardener</b-dropdown-item>
                    </b-dropdown>
                    <b-dropdown text="Sales Tools" class="m-md-2 main-nav-dropdown">
                        <b-dropdown-item href="/sales-tools/learning">Learning Center</b-dropdown-item>
                        <b-dropdown-item href="/sales-tools/literature">Literature</b-dropdown-item>
                        <b-dropdown-item href="/sales-tools/videos">Videos</b-dropdown-item>
                    </b-dropdown>
                    <b-nav-item href="https://www.amazon.com/stores/WestChester/page/543ACA2A-20AE-4A4A-800E-BB61C4257567?ref_=ast_bln" target="_blank" aria-label='Link opens in new window (amazon.com/stores/WestChester)'>BUY NOW</b-nav-item>
                    <!-- <b-nav-item to="/learning">{{
                        $t("nav.learning")
                    }}</b-nav-item> -->
                </b-navbar-nav>
                <div
                    class="ml-auto d-flex justify-content-center"
                    id="right-side-menu"
                >
                    <!-- <local-switcher v-if="useLocale"></local-switcher> -->
                    <div
                        class="pip-login-bar d-flex flex-column justify-content-center dropdown"
                        v-if="useAdmin"
                    >
                        <div class=" dropdown-toggle" data-toggle="dropdown" role="button" tabindex="0">
                            <div v-if="isLoggedIn" class="px-3">
                                <div class="welcome">
                                    <small class="d-block">Welcome</small>
                                    <span
                                        >{{ user.f_name }} {{ user.l_name }}
                                        <i class="pl-2 fas fa-chevron-down"></i
                                    ></span>
                                </div>
                            </div>
                            <div v-else class="px-5">
                                <div class="login ">
                                    Distributor Log in
                                </div>
                            </div>
                        </div>

                        <div class="dropdown-menu ">
                            <div v-if="isLoggedIn" class="dashboard-menu">
                                <ul>

                                    <li id="account">
                                        <router-link :to="{ name: 'myAccount' }"
                                            >My Account</router-link
                                        >
                                        <a
                                            href="javascript:void(0);"
                                            @click.prevent="logout" id="logOut"
                                            >Log Out</a
                                        >
                                    </li>
                                    <li v-if="user.user_group_id == 8" id="userlist">
                                        <router-link :to="{ name: 'verify-user' }"
                                            >Verify User</router-link
                                        >
                                    </li>

                                </ul>

                                <small class="menu-subheading">EMPLOYEES only</small>
                                <ul class="pb-2">
                                    <li>
                                        <router-link :to="{ name: 'myTools' }"
                                            >My Tools</router-link
                                        >
                                    </li>
                                    <li>
                                        <a href="https://form.asana.com/?k=53A02TdaaoHj3o9ukhYpew&d=1202255696728322" target="_blank"
                                            >Creative Request Form</a
                                        >
                                    </li>
                                </ul>
                                <small class="menu-subheading">portals</small>
                                <ul class="pb-2">
                                    <li >
                                        <router-link :to="{ name: 'SpecSheetDownload' }"
                                            >Spec Sheet Portal</router-link
                                        >
                                    </li>
                                </ul>
                                <small v-if="user.user_group_id != 1 && user.user_group_id != 0 && user.user_group_id != 7" class="menu-subheading">pricing</small>
                                <ul  v-if="user.user_group_id != 1 && user.user_group_id != 0 && user.user_group_id != 7" class="pb-2">
                                    <li>
                                        <router-link :to="{ name: 'DynamicPriceList' }">
                                            Dynamic Price List
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{ name: 'PriceListPortal' }">
                                            Price List Portal
                                        </router-link>
                                    </li>
                                    <li v-if="priceDeviationAdmins.includes(user.id) || user.user_group_id == 9 || user.user_group_id == 10">
                                        <router-link :to="{ name: 'PriceWorkflowSubmission' }">
                                            Pricing Activity Workflow
                                        </router-link>
                                    </li>

                                </ul>
                                <small v-if="user.user_group_id != 1 && user.user_group_id != 0 && user.user_group_id != 7" class="menu-subheading">resources</small>
                                <ul v-if="user.user_group_id != 1 && user.user_group_id != 0 && user.user_group_id != 7" class="pb-2">
                                    <li>
                                        <a :href="richProductFileURL" download="PIP-Retail-Product-Information-2025-07.xlsx">Rich Product Detail - July 2025</a>
                                    </li>
                                </ul>
                                <ul class="pb-2">
                                    <li >
                                        <router-link :to="{ name: 'ImageGallery' }">
                                            Download Product Images
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                            <div v-else class="login-block">
                                <div class="text-center mb-3">
                                    <img
                                        src="/images/west-chester-logo.svg"
                                        alt="logo"
                                        class="d-inline-block mb-2"
                                    />
                                    <span class="d-block text-center"
                                        >DISTRIBUTOR TOOLS</span
                                    >
                                </div>
                                <div>
                                    <small class="d-block"
                                        >Don't have an account?</small
                                    >
                                    <small class="mb-4 d-inline-block"
                                        ><router-link
                                            :to="{ name: 'login' }"
                                            class="text-light"
                                            >Click here to Sign Up</router-link
                                        ></small
                                    >
                                </div>
                                <form>
                                    <div class="form-group">
                                        <label for="email"
                                            >Email Address:</label
                                        >
                                        <input
                                            type="text"
                                            name="email"
                                            class="form-control"
                                            v-model="email"
                                        />
                                    </div>
                                    <div class="form-group mb-1">
                                        <label for="password">Password:</label>
                                        <input
                                            type="password"
                                            name="password"
                                            class="form-control"
                                            v-model="password"
                                        />
                                    </div>
                                    <small class="d-block text-right"
                                        ><router-link
                                            :to="{ name: 'reset-password' }"
                                            class="text-light"
                                            >Did you forget your
                                            password?</router-link
                                        ></small
                                    >

                                    <button
                                        class="btn-round-white pt9rem mt-4 "
                                        type="submit"
                                        :disabled="loading"
                                        @click.prevent="login"
                                    >
                                        Login
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="flyout-menu" @click="toggleDisplayMenu" @mouseleave="toggleDisplayMenu">
                        <font-awesome-icon :icon="['fass', 'bars']" />
                        <AdditionalMenu v-show="displayMenu"></AdditionalMenu>
                    </div>

                    <div
                        class="search text-light "
                        data-toggle="modal"
                        data-target="#searchPanel"
                        v-if="useProducts"
                    >
                        <i class="fas fa-search mr-2"></i>
                    </div>
                </div>
            </b-collapse>
            <i
                id="mobile-search"
                data-toggle="modal"
                data-target="#searchPanel"
                class="fas fa-search d-lg-block d-xl-none"
                v-if="useProducts"
            ></i>
        </b-navbar>
        <search></search>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import validationErrors from "../mixins/validationErrors";
import { logIn, logOut } from "../utils/auth";
import AdditionalMenu from "./AdditionalMenu.vue";
export default {
    components: { AdditionalMenu },
    mixins: [validationErrors],
    data() {
        return {
            email: null,
            password: null,
            loading: false,
            success: false,
            isScroll: false,
            hover:false,
            displayMenu: false,
            richProductFileURL: "/archive/products/info/PIP-Retail-Product-Information-2025-07.xlsx"
        };
    },
    computed: {
        ...mapState([
            "categories",
            "isLoggedIn",
            "priceDeviationAdmins",
            "userEmail",
            "user",
            "useProducts",
            "useAdmin",
            "useLocale"
        ])
    },
    created() {
        if (this.isLoggedIn == true) {
            axios.get(`/api/getUserByEmail/${this.userEmail}/`).then(response => {
                this.$store.state.user = response.data;
            });
        }

        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll (event) {
            if(window.scrollY<=100){
                return this.isScroll=false;
            }else{
                 return this.isScroll=true;
            }
        },
        getLogo() {
            return "/images/pip-logo-white.svg";
        },
        getWCLogo() {
            return "/images/west-chester-logo.svg";
        },
        submenuHeight(subcategory){
            var maxHeight=false;
            if(this.categories.length<subcategory.length){
                maxHeight=false;
            }else{
                maxHeight=true;
            }
            return maxHeight;
        },
        toggleDisplayMenu(event) {
            if (event.type == "click") {
                if(this.displayMenu) {
                    this.displayMenu = false;
                } else {
                    this.displayMenu = true;
                }
            }
            if (event.type == "mouseout" || event.type == "mouseleave") {
                if(this.displayMenu && event.clientY > 51) {
                    this.displayMenu = false;
                }
            }
        },
        // verify if the user email and password is correct
        async login(){

            try {
                await axios.get(`/sanctum/csrf-cookie`);
                await axios.post(`/login`, {
                        email: this.email,
                        password: this.password
                    }).then(response=>{

                        if(response.data.success){
                            //save user information in the local storage
                            logIn(
                                response.data.user.email,
                                response.data.user.approved,
                                response.data.user.user_group_id
                            );
                            //updating login info
                            axios.get(`/api/user/update/login/${response.data.user.id}/`);

                            //store user in state
                            this.$store.dispatch("loadUser");

                            if(this.$route.query.from){
                                this.$router.push({ name: this.$route.query.from});
                            }else{
                                this.$router.push({ name: "home"});
                            }
                            // const previousPath = this.$route.query.from || '/'; // Use home route if there's no previous path
                            //     this.$router.push(previousPath);
                        }
                        else{

                            switch(response.data.msg){
                                case "Not Verified":
                                    this.$router.push({ name: "login", query: {verify: "false"} });
                                    break;
                                case "No Access":
                                    this.$router.push({ name: "login", query: {access: "false"} });
                                    break;
                            }
                        }


                    });
            } catch (error) {
                this.$router.push({ name: "login", query: {login: "false"} });

            }
        },
        async logout() {
            try {
                axios.post("/logout");
                this.$store.dispatch("logout");
                this.$router.push({ name: "home" });
            } catch (error) {
                this.$store.dispatch("logout");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.showMenu{
    display:block;
}
.logo-bg { background: #000;}
.logo-bg::after { background:#000; }


.fix-nav{
    // background:rgba(0,0,0,0.5) !important;
    @media screen and (max-width: 1200px) {  background:#cd1b00 !important; }
}


// #main-nav .navbar-nav .nav-item .nav-link{
//     color:#ffffff;
// }
//display submenu on hover
.navbar-nav li:hover > ul.dropdown-menu.submenu {
    display: block;
}

ul#products-menu {
    width: 225px;
    border-radius: none;
    top: 123%;
}

.dropdown-menu.submenu {
    min-height: 130px;
    & > li {
        padding: 0.26em 0.8rem;
        &:first-child {
            &:hover {
                background: transparent;
            }
        }
    }
}
.dropdown-submenu{
    height:200px;
}
.dropdown-submenu > .dropdown-menu {
    top: -3px;
    left: 100%;
    border-radius: 0;
    width: 225px;
}

.submenu-header {
    margin: 0;
    font-weight: 700;
    font-family: "acumin-pro-condensed", Helvetica, Arial, sans-serif;
    font-size: 1rem;
    padding: 0.25rem 0.7rem;
    &:before {
        content: "///";
        color: lightgray;
        display: inline-block;
        font-weight: bold;
    }
}

.dropdown-menu {
    padding: 0;
    border-radius: 0;
    left: -0.5px;
    .dropdown-item {
        &::after {
            position: absolute;
            top: 17px;
            right: -4px;
        }
    }
    li {
        transition: all 0.4s ease-out;
        border-bottom: 1px dotted #333;
        padding: 0 0.5rem;
        &:last-child {
            border-bottom: none;
        }
        a {
            &:hover {
                //rotate caret on hover
                &:after {
                    text-decoration: underline;
                    transform: rotate(-90deg);
                }
            }
            &:after {
                color: lightgray;
            }

            &::before {
                content: "///";
                color: lightgray;
                margin-right: 0.2em;
                display: inline-block;
                font-weight: bold;
            }
        }
    }
    .submenu {
        li {
            a {
                color: #333;
                font-size: 1rem;
                font-family: "acumin-pro-condensed", Helvetica, Arial,
                    sans-serif;
                padding: 0;
                margin: 0;
                &:before {
                    content: "";
                }
            }
        }
    }
}

.dropdown-item {
    font-family: "acumin-pro-condensed", Helvetica, Arial, sans-serif;
    font-weight: 700;
    font-size: 1rem;
    letter-spacing: unset;
    color: #333;
    padding: 0.25rem;
    position: relative;
    &:hover,
    &:focus {
        background: transparent;
    }
}

#right-side-menu {
    position: absolute;
    right: 0;

    height: 50px;
}

.search {
    font-size: 1rem;
    padding: 0 1rem ;

    text-align: center;
    background:#cd1b00;
    &:hover {
        cursor: pointer;
    }
}

.logo-bg {
    background: #cd1b00;
    height: 90px;
    position: absolute;
    top: 0;
    left: 0;
    width: 255px;
    z-index: 1;
    &::after {
        content: "";
        position: absolute;
        top: 4px;
        right: -22px;
        width: 44px;
        height: 86px;
        background: #cd1b00;
        transform: skew(-27deg, 0deg);
    }
}

i.fas.fa-bars {
    transform: translateY(-36px);
    color: white;
    position: absolute;
    top: 3.2rem;
    left: 2rem;
    z-index: 9;
    font-size: 1.5rem;

}

//Search Panel Styles
.fa-search {
    color: white;
    &:hover {
        cursor: pointer;
    }
}

i#mobile-search {
    position: absolute;
    right: 2rem;
    top: 1.9rem;
    font-size: 1.4rem;
}

.local-switcher {
    background: #111;
    padding: 0.59rem 0.5rem;
    border: none;
}
svg#cart {
    width: 10px;
    height: 10px;
    margin: 0.2rem;
}

#cart-container {
    padding: 0.25rem 0.8rem;
    align-items: center;
    background: #333;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}
span#cart-quantity {
    color: whitesmoke;
    // transform: translate(8px, -2px);
    font-size: 0.7rem;
}
i.fas.fa-shopping-cart {
    color: whitesmoke;
    font-size: 1rem;
}
#pip-global-img {
    font-size: 1rem;
    svg {
        color: white;
        margin: 0;
    }
}
.flyout-menu {
    background: #e6e6e7;
    color:#666;
    font-size: 1.4rem;
    padding: 0.5rem 0;
    // temp
    -ms-flex-item-align: stretch;
    align-self: stretch;
    -webkit-align-self: stretch;
    -moz-align-self: stretch;
    cursor: pointer;
    display: inline-block;
    flex: 0 1 20%;
    position: relative;
    text-align: center;
}
</style>
